// extracted by mini-css-extract-plugin
module.exports = {"MainWrap":"HeaderControls_MainWrap__3TNVm","IconWrap":"HeaderControls_IconWrap__3zX_z"};